import { Pipe, PipeTransform } from '@angular/core';
import { defaultIfNullish } from 'src/app/shared/util/helper.util';

@Pipe({
  name: 'questionnaireRisk'
})
export class QuestionnaireRiskPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    value = value.split('<br>')[1];
    return defaultIfNullish(value, 'N/A');
  }
}
